const PhotoSwipe = require('../../../node_modules/photoswipe/dist/photoswipe.js');
const PhotoSwipeUIDefault = require('../../../node_modules/photoswipe/dist/photoswipe-ui-default.js');

export default class Gallery {
    constructor(el) {
        this.el = el;
        this.images = this.el.querySelectorAll('.imageGallery__column.js-openImage');
        this.lightboxEl = document.querySelector('.pswp');
        this.lightboxItems = [];
        this.currentIndex = 0;

        if (this.images.length > 0) {
            this.thisSetOptions();
            this.thisPrepareLightboxItems();
            this.bindEvents();
        }
    }

    bindEvents() {
        for (let i = 0; i < this.images.length; i++) {
            this.images[i].addEventListener('click', () => this.openLightBox(i));
        }
    }

    thisSetOptions() {
        this.options = {
            index: 0,
            history: false,
            shareEl: false,
            bgOpacity: 0.8,
            showHideOpacity: true,
            timeToIdle: false
        };
    }

    thisPrepareLightboxItems() {
        const items = [];

        for (let i = 0; i < this.images.length; i++) {
            let image = this.images[i].querySelector('.imageGallery__image');
            const item = {
                src: image.dataset.image,
                w: image.dataset.width,
                h: image.dataset.height,
                title: image.dataset.title
            };
            items.push(item);
        }

        this.lightboxItems = items;
    }

    openLightBox(index) {
        this.options.index = index;
        const gallery = new PhotoSwipe(this.lightboxEl, PhotoSwipeUIDefault, this.lightboxItems, this.options);
        gallery.init();
    }
}



// WEBPACK FOOTER //
// ./src/components/imageGallery/imageGallery.js